import DefaultButton from "./DefaultButton";

const PopoutButton = ({ onClick, ...args }) => {
    return onClick && <DefaultButton kind="popout" onClick={onClick} {...args}></DefaultButton>;
};

export default PopoutButton;